import React from 'react';

const ReviewTab = ({ questions, employees, onSelectQuestion }) => {
    const questionsToReview = questions.filter(q => q.status === 'in-review');

    return (
        <div className="bg-white rounded-xl shadow-sm overflow-hidden">
            <h2 className="text-2xl font-bold text-slate-800 p-6">Submissions to Review</h2>
            {questionsToReview.length > 0 ? (
                <ul className="divide-y divide-slate-200">
                    {questionsToReview.map(question => (
                        <li 
                            key={question.id} 
                            onClick={() => onSelectQuestion(question)}
                            className="p-4 hover:bg-slate-50 cursor-pointer"
                        >
                            <div className="flex justify-between items-center">
                                <div>
                                    <p className="font-semibold text-slate-800">{question.text}</p>
                                    <p className="text-sm text-slate-500">
                                        Submitted by: {employees.find(e => e.id === question.assignedTo)?.name || 'N/A'}
                                    </p>
                                </div>
                                <span className="text-indigo-600 font-semibold">Review</span>
                            </div>
                        </li>
                    ))}
                </ul>
            ) : (
                <p className="p-6 text-slate-500">There are no submissions currently in review.</p>
            )}
        </div>
    );
};

export default ReviewTab;
